import { Module } from '@vuex/decorators';
import { TablePanel } from 'table-panel';

import { modals } from '@modals';
import { auth, RoleId } from '@auth';
import { LambdaLog } from '@models';

import TableCellLambdaLogLevel from '@components/TableCells/TableCellLambdaLogLevel.vue';
import TableCellLambdaLogMemory from '@components/TableCells/TableCellLambdaLogMemory.vue';
import TableCellLambdaLogDuration from '@components/TableCells/TableCellLambdaLogDuration.vue';
import { faEye } from '@icons/solid/faEye';
import { faAws } from '@icons/brands/faAws';


const columns: TablePanel.Column<LambdaLog>[] = [
  {
    key: 'level',
    label: 'Level',
    component: TableCellLambdaLogLevel,
    value: (item) => {
      return item;
    },
  },
  {
    key: 'timestamp',
    label: 'Timestamp',
    sortByFormatted: true,
    value: ({ timestamp }) => {
      return new Date(timestamp).toLocaleString('en-US', {
        timeZoneName: 'short',
      });
    },
  },
  {
    key: 'functionName',
    label: 'Function Name',
    value: (item) => {
      return item.functionName;
    },
  },
  {
    key: 'memory',
    label: 'Memory',
    component: TableCellLambdaLogMemory,
    value: (item) => {
      return item;
    },
  },
  {
    key: 'duration',
    label: 'Duration',
    component: TableCellLambdaLogDuration,
    value: (item) => {
      return item;
    },
  }
];

const operations: TablePanel.Row.Operation<LambdaLog>[] = [
  {
    label: 'View',
    icon: faEye,
    fn: (item) => {
      console.log(item);
    },
  },
  {
    label: 'CloudWatch',
    icon: faAws,
    fn: (item) => {
      window.open(item.cloudWatch, 'blank');
    }
  },
];



@Module({ namespaced: true })
export class LambdaLogsTablePanel
  extends TablePanel<LambdaLog>
  implements TablePanel.Props<LambdaLog>
{
  onPageChanged?: TablePanel.OnPageChangedCallback<LambdaLog>;
  readonly module = 'lambdaLogs';
  readonly pk = 'id';
  readonly loadPageAction = 'loadPage';
  readonly label = 'LAMBDA LOGS';
  readonly columns = columns;
  readonly operations = operations;

  get enabled() {
    return this.isActiveRole(RoleId.Reseller, RoleId.LasAdmin);
  }

  get progressive() {
    return this.isActiveRole(RoleId.LasAdmin);
  }
}
